module.exports = __webpack_public_path__ + "img/messenger-light.72729558.svg";